export default {
  generateGraphBatchRequestFromSection(section) {
    if (section && section.extSysApiSectionId) {
      return {
        id: section.extSysApiSectionId,
        method: "GET",
        url: `/groups/${section.extSysApiSectionId}/photos/48x48/$value`
      };
    }
  }
};
